import wpdmIcons from "../../libs/icons";
import Util from "../../libs/util";

const {InspectorControls, BlockControls, ColorPalette, RichText, AlignmentToolbar, MediaUpload, PanelColorSettings} = wp.editor;
const { TextControl,
    SelectControl,
    ServerSideRender,
    Modal,
    Button,
    PanelBody,
    PanelRow,
    RangeControl,
    ToggleControl,
    Panel,
    TreeSelect,
    RadioControl,
    FontSizePicker,
    withFallbackStyles,
    IconButton,
    Dashicon,
    Toolbar
} = wp.components;

const { registerBlockType } = wp.blocks;
const { Fragment } = wp.element;

const { __ } = wp.i18n;

registerBlockType('download-manager/call2action', {
    title: 'Call To Action',

    description: 'Call To Action UI',

    keywords: [
        __( 'bootstrap jumbotron component' ),
        __( 'call-to-action ui' ),
        __( 'call2action' ),
    ],

    icon: wpdmIcons.btnC2A(),

    category: 'wpdm-blocks',

    attributes: {
        actionType: {
            type: 'string',
            default: 'button',
        },
        title: {
            type: 'array',
            source: 'children',
            selector: '.title',
        },
        alignment: {
            type: 'string',
            default: 'center'
        },
        titleFontSize: {
            type: 'string',
            default: '20'
        },
        textFontSize: {
            type: 'string',
            default: '13'
        },
        buttonText: {
            type: 'array',
            source: 'children',
            selector: 'a',
            default: 'Call To Action',
        },
        buttonStyle: {
            type: 'string',
            default: 'btn btn-primary btn-lg'
        },
        buttonSize: {
            type: 'string',
            default: 'btn-lg'
        },
        link: {
            type: 'string',
            source: 'attribute',
            selector: 'a',
            attribute: 'href',
        },
        content: {
            type: 'array',
            source: 'children',
            selector: '.content',
        },
        buttonTextColor: {
            type: 'string',
            default: '#ffffff'
        },
        buttonBG: {
            type: 'string',
            default: '#333333'
        },
        ctaBG: {
            type: 'string',
            default: '#E9ECEF'
        },
        ctaBGx: {
            type: 'string',
            default: '#E9ECEF'
        },

        ctaBGAlpha: {
            type: 'string',
            default: '50'
        },

        bgCS1: {
            type: 'string',
            default: '0'
        },

        bgCS2: {
            type: 'string',
            default: '100'
        },

        gradAngle: {
            type: 'string',
            default: '45'
        },

        ctaBGImage: {
            type: 'string',
            default: null
        },

        ctaBGSize: {
            type: 'string',
            default: 'bg-cover'
        },

        ctaBGRepeat: {
            type: 'string',
            default: 'bg-no-repeat'
        },

        ctaBGImageID: {
            type: 'string',
            default: null
        },

        titleColor: {
            type: 'string',
            default: '#333333'
        },

        textColor: {
            type: 'string',
            default: '#333333'
        },
        className: {
            type: 'string',
            default: ''
        }
    },

    edit({attributes, className, setAttributes}) {

        const { title, content } = attributes;

        const onChangeContent = newContent => {
            setAttributes( { content: newContent } );
        };

        const onChangeTitle = newTitle => {
            setAttributes( { title: newTitle } );
        };

        const onChangeAlignment = newAlignment => {
            setAttributes( { alignment: newAlignment } );
        };

        const onChangeButton = buttonText => {
            setAttributes( { buttonText: buttonText } );
        };

        const onSelectImage = img => {
            setAttributes( {
                ctaBGImage: img.url
            } );
        };


        const onRemoveImage = () => {
            setAttributes({
                ctaBGImage: null,
                //imgAlt: null,
            });
        };



        const fontSizes = [
            {
                name: __( 'Small' ),
                slug: 'small',
                size: 12,
            },
            {
                name: __( 'Medium' ),
                slug: 'small',
                size: 16,
            },
            {
                name: __( 'Big' ),
                slug: 'small',
                size: 24,
            },
            {
                name: __( 'Extra Big' ),
                slug: 'xbig',
                size: 32,
            },
        ];

        /* Default colors */
        const defaultColors = Util.defaultColor();

        const fallbackFontSize = 16;
        const colorPaletteControl = '';

        var tfz = attributes.titleFontSize + 'px';
        var xfz = attributes.textFontSize + 'px';

        const rgba1 = Util.hexToRgba(attributes.ctaBG, attributes.ctaBGAlpha);
        const rgba2 = Util.hexToRgba(attributes.ctaBGx, attributes.ctaBGAlpha);
        const cs1 = attributes.bgCS1+"%";
        const cs2 = attributes.bgCS2+"%";
        const overlay = "linear-gradient( "+ attributes.gradAngle +"deg, " + rgba1 + " "+ cs1 + ", " + rgba2 + " "+ cs2 + "),";

        /* onchange functions */
        const onChangeButonTextColor = value => setAttributes( { buttonTextColor: value } );

        let actionTypeEditHTML = <a href={attributes.link} className={attributes.buttonStyle}
                                      style={{background: attributes.buttonBG, color: attributes.buttonTextColor}}>
            <RichText
                tagName={"span"}
                placeholder={__('Call To Action')}
                onChange={onChangeButton}
                value={attributes.buttonText}
            />
        </a>;
        let actionTypeOutputHTML = <a href={attributes.link} className={attributes.buttonStyle} style={{background: attributes.buttonBG, color: attributes.buttonTextColor}}>
            <RichText.Content
                placeholder={ __( 'Call To Action' ) }
                value={ attributes.buttonText }
            />
        </a>;
        if(attributes.actionType === 'search') {
            actionTypeEditHTML = <form className={"text-center"} method={"GET"} action={attributes.link} >
                <input name={"s"} style={{maxWidth: '100%', width: '500px', margin: '0px auto'}} type={"text"} className={"form-control input-lg"} placeholder={"Search..."}/>
            </form>;

            actionTypeOutputHTML = <form className={"text-center"} method={"GET"} action={attributes.link} >
                <input name={"s"} style={{maxWidth: '100%', width: '500px', margin: '0px auto'}} type={"text"} className={"form-control input-lg"} placeholder={attributes.buttonText}/>
            </form>;
        }




        return [

            <InspectorControls>
                <PanelBody>
                    <div className="w3eden">



                        <TextControl
                            label="Action URL"
                            help={ 'Where to go when someone clicks the button' }
                            value={ attributes.link }
                            onChange={ ( value ) => setAttributes( { link: value } ) }
                        />

                        <RadioControl
                            label="Action type"
                            help="The type of the current user"
                            selected={ attributes.actionType }
                            options={ [
                                { label: 'Button', value: 'button' },
                                { label: 'Search', value: 'search' },
                            ] }
                            onChange={ actionType => setAttributes( { actionType: actionType } ) }
                        />


                        <label>Text Alignment</label><br/>
                        <AlignmentToolbar
                            value={ attributes.alignment }
                            onChange={ onChangeAlignment }
                        />
                        <PanelBody title={ __( 'Text Options' ) }>
                            <label>Title Font Size</label><br/>
                            <FontSizePicker
                                fontSizes={ fontSizes }
                                value={ attributes.titleFontSize }
                                fallbackFontSize={ fallbackFontSize }
                                onChange={ fontSize => setAttributes( { titleFontSize: fontSize } ) }
                            />
                            <label>Text Font Size</label><br/>
                            <FontSizePicker
                                fontSizes={ fontSizes }
                                value={ attributes.textFontSize }
                                fallbackFontSize={ fallbackFontSize }
                                onChange={ fontSize => setAttributes( { textFontSize: fontSize } ) }
                            />
                        </PanelBody>


                        <PanelBody title={ __( 'Background Options' ) } initialOpen={ false }>


                            <div className={"panel panel-default"}>
                                <div className={"panel-heading"}>{__( 'Background Color Left' )}</div>
                                <div className={"panel-body"}>
                                <ColorPalette
                                    disableAlpha={ false }
                                    label={ __( 'Background Color' ) }
                                    value={ attributes.ctaBG }
                                    onChange={ ( value ) => setAttributes( { ctaBG: value } ) }
                                />
                                </div>
                            </div>
                            <div className={"panel panel-default"}>
                                <div className={"panel-heading"}>{__( 'Background Color Right' )}</div>
                                <div className={"panel-body"}>
                                <ColorPalette
                                    disableAlpha={ false }
                                    label={ __( 'Background Color' ) }
                                    value={ attributes.ctaBGx }
                                    onChange={ ( value ) => setAttributes( { ctaBGx: value } ) }
                                />
                                </div>
                            </div>

                            <div className={"panel panel-default"}>
                                <div className={"panel-heading"}>{ __( 'Select a background image:' ) }</div>
                                <div className={"panel-body"}>

                                <MediaUpload
                                    onSelect={ onSelectImage }
                                    type="image"
                                    value={ attributes.ctaBGImage }
                                    render={ ( { open } ) => (
                                        <div>
                                            <IconButton
                                                className="ab-cta-inspector-media"
                                                label={ __( 'Edit image' ) }
                                                icon="format-image"
                                                onClick={ open }
                                            >
                                                { __( 'Select Image' ) }
                                            </IconButton>

                                            { attributes.ctaBGImage && !! attributes.ctaBGImage.length && (
                                                <IconButton
                                                    className="ab-cta-inspector-media"
                                                    label={ __( 'Remove Image' ) }
                                                    icon="dismiss"
                                                    onClick={ onRemoveImage }
                                                >
                                                    { __( 'Remove' ) }
                                                </IconButton>
                                            ) }
                                        </div>
                                    ) }
                                >
                                </MediaUpload>
                                </div>
                            </div>
                            <div>
                                <label>Gradient Angle:</label><br/>
                                <RangeControl
                                    value={ attributes.gradAngle }
                                    onChange={ ( value ) => setAttributes( { gradAngle: value } ) }
                                    min={ -270 }
                                    max={ 360 }
                                    step={ 1 }
                                />
                                <label>Opacity:</label><br/>
                                <RangeControl
                                    value={ attributes.ctaBGAlpha }
                                    onChange={ ( value ) => setAttributes( { ctaBGAlpha: value } ) }
                                    min={ 0 }
                                    max={ 100 }
                                    step={ 1 }
                                />
                                <label>Color #1 Start:</label><br/>
                                <RangeControl
                                    value={ attributes.bgCS1 }
                                    onChange={ ( value ) => setAttributes( { bgCS1: value } ) }
                                    min={ 0 }
                                    max={ 100 }
                                    step={ 1 }
                                />
                                <label>Color #2 Start:</label><br/>
                                <RangeControl
                                    value={ attributes.bgCS2 }
                                    onChange={ ( value ) => setAttributes( { bgCS2: value } ) }
                                    min={ 0 }
                                    max={ 100 }
                                    step={ 1 }
                                />
                            </div>
                            { attributes.ctaBGImage && !! attributes.ctaBGImage.length && (
                                <div>
                                    <label>Background Size:</label><br/>
                                    <SelectControl
                                        value={ attributes.ctaBGSize }
                                        onChange={ ( value ) => setAttributes( { ctaBGSize: value } ) }
                                        options = { [
                                            { label: 'Auto', value: 'bg-auto' },
                                            { label: 'Cover', value: 'bg-cover' },
                                            { label: 'Contain', value: 'bg-contain' },
                                            { label: '100%', value: 'bg-100' },
                                        ] }
                                    />
                                    <label>Background Repeat:</label><br/>
                                    <SelectControl
                                        value={ attributes.ctaBGRepeat }
                                        onChange={ ( value ) => setAttributes( { ctaBGRepeat: value } ) }
                                        options = { [
                                            { label: 'No Repeat', value: 'bg-no-repeat' },
                                            { label: 'Repeat', value: 'bg-repeat' },
                                            { label: 'Repeat X', value: 'bg-repeat-x' },
                                            { label: 'Repeat Y', value: 'bg-repeat-y' },
                                        ] }
                                    />
                                </div>
                            ) }


                        </PanelBody>



                        <PanelColorSettings
                            title={ __( 'Button Text Color' ) }
                            initialOpen={ false }
                            colorSettings={ [ {
                                value: attributes.buttonTextColor,
                                onChange: onChangeButonTextColor,
                                label: __( 'Button Text Color' ),
                                colors: defaultColors,
                            } ] }
                        >
                        </PanelColorSettings>

                        <PanelColorSettings
                            title={ __( 'Button Background Color' ) }
                            initialOpen={ false }
                            colorSettings={ [ {
                                value: attributes.buttonBG,
                                onChange: buttonBG => setAttributes( { buttonBG: buttonBG } ),
                                label: __( 'Button Background Color' ),
                                colors: defaultColors,
                            } ] }
                        >
                        </PanelColorSettings>
                        <PanelColorSettings
                            title={ __( 'Title Color' ) }
                            initialOpen={ false }
                            colorSettings={ [ {
                                value: attributes.titleColor,
                                onChange: titleColor => setAttributes( { titleColor: titleColor } ),
                                label: __( 'Title Color' ),
                                colors: defaultColors,
                            } ] }
                        >
                        </PanelColorSettings>
                        <PanelColorSettings
                            title={ __( 'Text Color' ) }
                            initialOpen={ false }
                            colorSettings={ [ {
                                value: attributes.textColor,
                                onChange: textColor => setAttributes( { textColor: textColor } ),
                                label: __( 'Text Color' ),
                                colors: defaultColors,
                            } ] }
                        >
                        </PanelColorSettings>



                    </div>
                </PanelBody>
            </InspectorControls>
            ,

            <div className={"w3eden"}>
                <div className={ "jumbotron jumbotron-fluid " + attributes.ctaBGRepeat + " " + attributes.ctaBGSize } style={{background: overlay +" " + "url("+attributes.ctaBGImage+")" }}>
                    <div style={{textAlign: attributes.alignment}}>
                        <RichText
                            tagName={"h1"}
                            className={"title"}
                            style={{color: attributes.titleColor, fontSize: tfz}}
                            placeholder={ __( 'Title' ) }
                            onChange={ onChangeTitle }
                            value={ title }
                        />
                        <RichText
                            tagName={"div"}
                            className={"content"}
                            placeholder={ __( 'Content' ) }
                            onChange={ onChangeContent }
                            style={{color: attributes.textColor, fontSize: xfz}}
                            value={ content }
                        />
                        {actionTypeEditHTML}
                    </div>

                </div>
            </div>

            ];
    },
    save({attributes, className}) {
        const { title, content } = attributes;


        let actionTypeOutputHTML = <a href={attributes.link} className={attributes.buttonStyle} style={{background: attributes.buttonBG, color: attributes.buttonTextColor}}>
            <RichText.Content
                placeholder={ __( 'Call To Action' ) }
                value={ attributes.buttonText }
            />
        </a>;
        if(attributes.actionType === 'search') {

            actionTypeOutputHTML = <form className={"text-center"} method={"GET"} action={attributes.link} >
                <input name={"s"} style={{maxWidth: '100%', width: '500px', margin: '0px auto'}} type={"text"} className={"form-control input-lg"} placeholder={"Search..."}/>
            </form>;
        }



        var tfz = attributes.titleFontSize + 'px';
        var xfz = attributes.textFontSize + 'px';

        const rgba1 = Util.hexToRgba(attributes.ctaBG, attributes.ctaBGAlpha);
        const rgba2 = Util.hexToRgba(attributes.ctaBGx, attributes.ctaBGAlpha);
        const cs1 = attributes.bgCS1+"%";
        const cs2 = attributes.bgCS2+"%";
        const overlay = "linear-gradient( "+ attributes.gradAngle +"deg, " + rgba1 + " "+ cs1 + ", " + rgba2 + " "+ cs2 + "),";


        return(
            <div className={"w3eden"}>
                <div className={ "jumbotron jumbotron-fluid " + attributes.ctaBGRepeat + " " + attributes.ctaBGSize } style={{background: overlay +" " + "url("+attributes.ctaBGImage+")" }}>
                    <div style={{textAlign: attributes.alignment}}>
                        <RichText.Content
                            tagName={"h1"}
                            className={"title"}
                            style={{color: attributes.titleColor, fontSize: tfz}}
                            value={ title }
                        />
                        <RichText.Content
                            tagName={"div"}
                            className={"content"}
                            style={{color: attributes.textColor, fontSize: xfz}}
                            value={ content }
                        />
                        {actionTypeOutputHTML}
                    </div>

                </div>
            </div>
        );
    }
});
